import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { stringify } from 'qs';
import keys from 'lodash/keys';
import * as TYPES from './types';
import { extractProductReference } from '~/helpers/extract-helper';
import { fetchProduct, fetchProductCarousels } from '~/services/product';
export default {
  fetchProductCarousels(_ref, _ref2) {
    var _this = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref;
      let {
        alias,
        profileId,
        exclude
      } = _ref2;
      const reference = extractProductReference(alias);
      const product = yield fetchProductCarousels(_this, reference, profileId, exclude);
      commit(TYPES.SET_PRODUCT_CAROUSELS, product);
    })();
  },

  fetchProduct(_ref3, _ref4) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref3;
      let {
        alias,
        query,
        profileId
      } = _ref4;
      const reference = extractProductReference(alias);
      const product = yield fetchProduct(_this2, reference, query.offer, profileId);
      const {
        currentLocale
      } = _this2.state.i18n;
      const currentQuery = keys(query).length ? "?".concat(stringify(query)) : '';
      const currentAlias = "".concat(product.slug, "-").concat(product.reference, ".htm");

      if (alias !== currentAlias && process.server) {
        _this2.app.context.redirect(301, "/".concat(currentLocale.market, "/").concat(currentLocale.language, "/p/").concat(currentAlias).concat(currentQuery));
      }

      const redirectUrl = product && product.redirection && product.redirection.redirectUrl;

      if (redirectUrl && redirectUrl !== '#') {
        if (process.server) {
          const redirectCode = product.redirection.redirectHttpCode || 301;

          _this2.app.context.redirect(redirectCode, "".concat(redirectUrl).concat(currentQuery));
        } else {
          window.location.href = "".concat(redirectUrl).concat(currentQuery);
        }
      }

      commit(TYPES.SET_PRODUCT, product);
    })();
  }

};